const getNameOfVendor = (id, type, Stores) => {
    const list = Stores[type.toLowerCase()] || [];
    return list.filter(({ supplierId: listId }) => listId === id)[0]
}

export default getNameOfVendor
